import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0C65DA",
      "fill-rule": "evenodd",
      d: "M22.224 2.575a1.2 1.2 0 0 1 .401 1.649l-8.817 14.48a3.7 3.7 0 0 1-1.088 1.151 3.2 3.2 0 0 1-1.493.533 3.1 3.1 0 0 1-1.562-.275 3.5 3.5 0 0 1-1.244-.977l-4.553-5.607a1.2 1.2 0 0 1 1.864-1.513l4.552 5.606c.125.154.26.253.383.31s.24.075.352.065a.8.8 0 0 0 .364-.135c.13-.087.261-.22.375-.406l8.817-14.48a1.2 1.2 0 0 1 1.65-.401",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }